// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../style-loader/index.js!../css-loader/index.js!./jquery-ui.min.css");
if(typeof content === 'string') content = [[module.id, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = require("!../style-loader/lib/addStyles.js")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../style-loader/index.js!../css-loader/index.js!./jquery-ui.min.css", function() {
			var newContent = require("!!../style-loader/index.js!../css-loader/index.js!./jquery-ui.min.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/style-loader!./node_modules/jquery-ui-dist/jquery-ui.min.css
// module id = 165
// module chunks = 0